const getApiEndpoint = function () {
	return 'https://' + getEndpointHost() + '/panel';
};

const getWssEndpoint = function () {
	return 'wss://' + getEndpointHost() + '/panel/ws';
};

const getHostedAssetPath = function () {
	return `https://twitchstreamstickers.s3.us-east-2.amazonaws.com/${getEndpointHost()}`;
};

const getGlobalStickerAssetPath = function () {
	return getHostedAssetPath() + '/0.0.1';
};

const getCustomStickerAssetPath = function (channelId) {
	return getHostedAssetPath() + `/custom_stickers/${channelId}`;
};

const getEndpointHost = function () {
	const host = window.location.host;
	if (
		host.startsWith('localhost') ||
		host.startsWith('icomponent-ui.ngrok.io') ||
		host.startsWith('panel-test.ngrok-free.dev')
	) {
		//return 'icomponent-api.ngrok.io';
		return 'extension-dev.streamstickers.com';
	} else if (
		host.startsWith('20nmmhmwff58rb3ytcs4j3bevlux5r.ext-twitch.tv') ||
		host.startsWith('panel-dev.streamstickers.com')
	) {
		return 'extension-dev.streamstickers.com';
	} else if (host.startsWith('5tbyqce941455yffg7fzg36tp6or8p.ext-twitch.tv')) {
		return 'extension.streamstickers.com';
	} else {
		return 'extension-dev.streamstickers.com';
		// throw new Error('Invalid host.');
	}
};

const getDashboardLink = function () {
	let link = 'https://dashboard.streamstickers.com/home';
	if (getEndpointHost().includes('-dev')) {
		link = 'https://dashboard-dev.streamstickers.com/home';
	}
	return link;
};

export {
	getEndpointHost,
	getApiEndpoint,
	getWssEndpoint,
	getHostedAssetPath,
	getGlobalStickerAssetPath,
	getCustomStickerAssetPath,
	getDashboardLink,
};
